/*
 * EM Saved Projects — Sauvegarder un pack personnalisé sous un nom de projet
 * Storage : localStorage 'em_saved_projects' = [ { id, customName, packName, packId, handle, url, size, theme, themeLabel, total, articles, products, savedAt, hashState } ]
 */
(function () {
  const STORAGE_KEY = 'em_saved_projects';
  const PACK_META = window.EM_PACK_META;
  if (!PACK_META) return;

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; }
  }
  function save(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }

  /* ----- DOM refs ----- */
  const saveBtn = document.querySelector('[data-em-save-project]');
  const fab = document.querySelector('[data-em-projects-fab]');
  const fabCount = document.querySelector('[data-em-projects-fab-count]');
  const modal = document.querySelector('[data-em-projects-modal]');
  const list = document.querySelector('[data-em-projects-list]');

  function formatRelative(unixSec) {
    const diff = (Date.now() / 1000) - unixSec;
    if (diff < 60) return 'à l\'instant';
    if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
    if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
    return `il y a ${Math.floor(diff / 86400)} j`;
  }

  function updateFab() {
    const projects = load();
    if (!fab) return;
    if (projects.length === 0) { fab.hidden = true; return; }
    fab.hidden = false;
    if (fabCount) fabCount.textContent = projects.length;
  }

  function renderList() {
    const projects = load().sort((a, b) => b.savedAt - a.savedAt);
    if (!list) return;
    if (projects.length === 0) {
      list.innerHTML = '<p class="em-projects-modal__empty">Aucun projet sauvegardé.<br>Cliquez sur l\'icône <strong>💾</strong> en bas pour sauvegarder votre pack actuel.</p>';
      return;
    }
    list.innerHTML = projects.map(p => `
      <article class="em-project-card" data-em-project-id="${p.id}">
        <div class="em-project-card__top">
          <h3 class="em-project-card__name">${escapeHtml(p.customName)}</h3>
          <button type="button" class="em-project-card__delete" data-em-project-delete="${p.id}" aria-label="Supprimer">×</button>
        </div>
        <div class="em-project-card__pack">${escapeHtml(p.packName)}</div>
        <div class="em-project-card__meta">
          <span>${escapeHtml(p.products || '0')} produits · ${escapeHtml(p.articles || '0')} articles</span>
          <strong>${escapeHtml(p.total || '—')}</strong>
        </div>
        <div class="em-project-card__time">Sauvegardé ${formatRelative(p.savedAt)}</div>
        <a class="em-project-card__open" href="${escapeHtml(p.url + p.hashState)}">Reprendre ce projet →</a>
      </article>
    `).join('');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c =>
      ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])
    );
  }

  // Sauvegarde le pack courant comme projet
  function saveAsProject() {
    const name = window.prompt('Nom de ce projet :\n\n(ex : « Loft Marais », « Studio Bertrand »…)', '');
    if (!name || !name.trim()) return;
    const customName = name.trim().slice(0, 60);
    const projects = load();
    const totalEl = document.querySelector('[data-total-price]');
    const countEl = document.querySelector('[data-total-count]');
    const productsEl = document.querySelector('[data-total-products]');
    const project = {
      id: 'proj-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7),
      customName,
      packName: PACK_META.name,
      packId: PACK_META.id,
      handle: PACK_META.handle,
      url: PACK_META.url,
      size: PACK_META.size,
      theme: PACK_META.theme,
      themeLabel: PACK_META.themeLabel,
      total: totalEl ? totalEl.textContent.trim() : '',
      articles: countEl ? countEl.textContent.trim() : '',
      products: productsEl ? productsEl.textContent.trim() : '',
      savedAt: Math.floor(Date.now() / 1000),
      hashState: location.hash || '',
    };
    projects.push(project);
    save(projects);
    updateFab();
    renderList();

    // Toast feedback
    showToast(`✓ Projet « ${customName} » sauvegardé`);
  }

  function deleteProject(id) {
    save(load().filter(p => p.id !== id));
    updateFab();
    renderList();
  }

  // Toast helper
  function showToast(msg) {
    let t = document.querySelector('.em-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'em-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.remove('em-toast--show');
    void t.offsetWidth;
    t.classList.add('em-toast--show');
    clearTimeout(t._tmr);
    t._tmr = setTimeout(() => t.classList.remove('em-toast--show'), 2400);
  }

  /* ----- Wiring ----- */
  if (saveBtn) saveBtn.addEventListener('click', saveAsProject);
  if (fab) fab.addEventListener('click', () => {
    renderList();
    if (modal) modal.hidden = false;
    document.body.style.overflow = 'hidden';
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-em-projects-close]')) {
      if (modal) modal.hidden = true;
      document.body.style.overflow = '';
      return;
    }
    const del = e.target.closest('[data-em-project-delete]');
    if (del) {
      if (confirm('Supprimer ce projet ?')) deleteProject(del.dataset.emProjectDelete);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && !modal.hidden) {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
  });

  updateFab();
})();
